import { IImageConverter } from './image-converter.interface';

export class ImageConverter implements IImageConverter {
  /** Преобразовать изображени.
   * @param {Blob} blob
   * @return {Promise<Blob>}
   * */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async convert(image: Blob): Promise<Blob> {
    throw new Error('Неподдерживаемый тип изображения');
  }
}
